import { Card } from "../ui/Card";

export default function AdminDashboard() {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <h2 className="text-lg font-semibold mb-2">Total Users</h2>
          <p className="text-2xl font-bold">#</p>
        </Card>
  
        <Card>
          <h2 className="text-lg font-semibold mb-2">Active Sessions</h2>
          <p className="text-2xl font-bold">#</p>
        </Card>
  
        <Card>
          <h2 className="text-lg font-semibold mb-2">Pending Approvals</h2>
          <p className="text-2xl font-bold">#</p>
        </Card>
      </div>
    )
  }